import React, { Component } from "react";
import "../../assets/css/main.css";
// import { ScaleLoader } from "react-spinners";
// import { css } from "react-emotion";
import API from "@aws-amplify/api";
import aws_exports from "../../aws-exports";
import Amplify from "aws-amplify";
import PageNotFound from "../pageNotFound";
import "@fancyapps/fancybox";
import { connect } from "react-redux";
import Header from "../../common/header";
import Footer from "../../common/footer";
import Preview from "./UsageEmail.PNG";
Amplify.configure(aws_exports);

// const override = css`
//   display: block;
//   margin: 0 auto;
//   border-color: red;
// `;

let apiName = "apide08d634";
let path = "/users";
let checked = "";
// eslint-disable-next-line
let modalClose = false;


class WithAccountNumber extends Component {
  constructor(props) {
    super(props);
    // console.log(this.props)
    this.state = {
      firstname:"",
      accountType: "",
      textChecked: false,
      emailChecked: false,
      mailChecked: false,
      agree: false,
      disagree: false,
      phoneNumber: "",
      phoneError: false,
      originalPhone: "",
      newPhone: "",
      editPhone: false,
      updatedPhone: false,
      originalPhoneError: false,
      maskPhoneNumber: "",
      close: true,
      email: "",
      originalEmail: "",
      newEmail: "",
      emailError: false,
      editEmail: false,
      originalEmailError: false,
      maskEmail: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      maskAddress: "",
      maskZip: "",
      addressError: false,
      cityError: false,
      stateError: false,
      zipError: false,
      savePhone: false,
      saveEmail: false,
      saveMail: false,
      originalAddress: "",
      originalCity: "",
      originalState: "",
      originalZip: "",
      newAddress: "",
      newCity: "",
      newState: "",
      newZip: "",
      originalAddressError: false,
      originalCityError: false,
      originalStateError: false,
      originalZipError: false,
      editMail: false,
      smsConsent: 0,
      smsConsentModal: true,
      notification: false,
      phoneVerified: false,
      emailVerified: false,
      newEmailVerified: false,
      newEmailError: false,
      confirmEmailVerified: false,
      mailVerified: false,
      message: "",
      page: "",
      newPhoneError: false,
      confirmEmail: "",
      confirmEmailError: false,
      confirmPhone:"",
      confirmPhoneVerified: false,
      confirmPhoneError: false
    };
    this.handleMailPreferences = this.handleMailPreferences.bind(this);
    this.phoneValidation = this.phoneValidation.bind(this);
    this.newPhoneValidation = this.newPhoneValidation.bind(this);
    this.emailValidation = this.emailValidation.bind(this);
    this.mailValidation = this.mailValidation.bind(this);
    this.newEmailValidation = this.newEmailValidation.bind(this);
  }

  // session = () => {
  //   var hours = 24;
  //   var now = new Date().getTime();
  //   var setupTime = localStorage.getItem('setupTime');
  //   if (setupTime == null) {
  //     localStorage.setItem('setupTime', now)
  //   } else {
  //     if(now-setupTime > hours*60*60*1000) {
  //       localStorage.clear()
  //       localStorage.setItem('setupTime', now);
  //     }
  //   }
  // }

  handlePhoneChange = event => {
    if(event.target.value === "") {
      this.setState({ phoneError: true });
    }
    this.setState({ phoneNumber: event.target.value });
  };
  handleOriginalPhoneChange = event => {
    if(
      event.target.value === ""
    ) {
      this.setState({ originalPhoneError: true });
    } else {
      this.setState({ originalPhoneError: false });
    }
    this.setState({ originalPhone: event.target.value });
  };
  handleNewPhoneChange = event => {
    if(event.target.value === "") {
      this.setState({ phoneError: true });
    } else {
      this.setState({ phoneError: false });
    }
    this.setState({ newPhone: event.target.value });
  };
  handleConfirmPhoneChange = event => {
    if(event.target.value === "") {
      this.setState({ confirmPhoneError: true });
    } else {
      this.setState({ confirmPhoneError: false });
    }
    this.setState({ confirmPhone: event.target.value });
  };
  handleEmailChange = event => {
    if(event.target.value === "") {
      this.setState({ emailError: true });
    }
    this.setState({ email: event.target.value });
  };
  handleOriginalEmailChange = event => {
    if(event.target.value === "") {
      this.setState({ originalEmailError: true });
    } else {
      this.setState({ originalEmailError: false });
    }
    this.setState({ originalEmail: event.target.value });
  };
  handleConfirmEmailChange = event => {
    if(event.target.value === "") {
      this.setState({ confirmEmailError: true });
    } else {
      this.setState({ confirmEmailError: false });
    }
    this.setState({ confirmEmail: event.target.value });
  };
  handleNewEmailChange = event => {
    if(event.target.value === "") {
      this.setState({ emailError: true });
      modalClose = false
    } else {
      this.setState({ emailError: false });
      modalClose = true
    }
    this.setState({ newEmail: event.target.value });
    //this.props.dispatch({ type: "ADD_EMAIL", payload: event.target.value });
  };
  handleMailChange = (event, type) => {
    this.setState({
      [event.target.id]: event.target.value
    });
    switch (type) {
      case "address":
        if(event.target.value === "") {
          this.setState({ addressError: true });
          modalClose = false
        } else {
          this.setState({ addressError: false });
          modalClose = true
        }
        this.setState({ newAddress: event.target.value });
        break;
      case "city":
        if(event.target.value === "") {
          this.setState({ cityError: true });
          modalClose = false
        } else {
          this.setState({ cityError: false });
          modalClose = true
        }
        this.setState({ newCity: event.target.value });
        break;
      case "state":
        if(event.target.value === "") {
          this.setState({ stateError: true });
          modalClose = false
        } else {
          this.setState({ stateError: false });
          modalClose = true
        }
        this.setState({ newState: event.target.value });
        break;
      case "zip":
        if(event.target.value === "") {
          this.setState({ zipError: true });
          modalClose = false
        } else {
          this.setState({ zipError: false });
          modalClose = true
        }
        this.setState({ newZip: event.target.value });
        break;
      case "originalAddress":
        if(event.target.value === "") {
          this.setState({ originalAddressError: true });
        } else {
          this.setState({ originalAddressError: false });
        }
        break;
      case "originalCity":
        if(event.target.value === "" || event.target.value.toUpperCase() !== localStorage.getItem("city").toUpperCase()) {
          this.setState({ originalCityError: true });
        } else {
          this.setState({ originalCityError: false });
        }
        break;
      case "originalState":
        if(event.target.value === "" || event.target.value !== localStorage.getItem("state")) {
          this.setState({ originalStateError: true });
        } else {
          this.setState({ originalStateError: false });
        }
        break;
      case "originalZip":
        if(event.target.value === "") {
          this.setState({ originalZipError: true });
        } else {
          this.setState({ originalZipError: false });
        }
        break;
      default:
        break;
    }
  };
  handleTextChecked = event => {
    checked = "phone";
    if(this.state.agree) {
      if(event.target.checked) {
        this.setState({ textChecked: true, disagree: false });
      }
    } else {
      if(!event.target.checked) {
        this.setState({ textChecked: false, agree: false });
      }
    }
  };
  handleEmailChecked = event => {
    checked = "email";
    if(this.state.emailVerified) {
      if(event.target.checked) {
        localStorage.setItem("emailNewstips", "1")
        this.setState({ emailChecked: true, message: "Your email address has successfully been subscribed to the requested email list." });
        this.handleEmailPreferences();
      }
      if(!event.target.checked) {
        localStorage.setItem("emailNewstips", "2")
        this.setState({ emailChecked: false, message: "Your email address has been successfully removed from the requested email list." });
        this.handleEmailPreferences();
      }
    }
  };
  handleMailChecked = event => {
    checked = "mail";
    if(this.state.mailVerified) {
      if(event.target.checked) {
        localStorage.setItem("mailNewstips", "1")
        this.setState({ mailChecked: true, message: "Your address has been successfully added to the requested mailing list." });
        this.handleMailPreferences();
      }
      if(!event.target.checked) {
        localStorage.setItem("mailNewstips", "2")
        this.setState({ mailChecked: false, message: "Your address has been successfully removed from the requested mailing list." });
        this.handleMailPreferences();
      }
    }
  };
  handleAgree = () => {
    localStorage.setItem("smsGlobal", "1")
    setTimeout(
      function() {
        this.setState({ textChecked: true, smsConsent: 1, agree: true, disagree: false, message:"Your mobile number has been successfully added to the requested SMS list.", close: true });
      }.bind(this),
      1000
    );
    this.handlePhonePreferences();
  };
  handleDisagree = () => {
    localStorage.setItem("smsGlobal", "2")
    setTimeout(
      function() {
        this.setState({
          smsConsent: 2,
          textChecked: false,
          disagree: true,
          agree: false,
          savePhone: true,
          close: true,
          message:"Your mobile number has been successfully removed from the requested SMS list.",
        });
      }.bind(this),
      1000
    );
    this.handlePhonePreferences();
  };
  async mailValidation(event){
    this.setState({ originalAddressError: false, originalCityError: false, originalStateError: false, originalZipError: false });
    if (this.state.originalAddress === "") {
      this.setState({ originalAddressError: true });
      modalClose = false
      return false;
    }
    if (this.state.originalCity === "") {
      this.setState({ originalCityError: true });
      modalClose = false
      return false;
    }
    if (this.state.originalState === "") {
      this.setState({ originalStateError: true });
      modalClose = false
      return false;
    }
    
    if (this.state.originalZip === "") {
      this.setState({ originalZipError: true });
      modalClose = false
      return false;
    }
    event.preventDefault();
    const zipRex = /^\d{5}(?:[-\s]\d{4})?$/;
    if(!this.state.editMail) {
      let myInit2 = {
        headers: {
          uniqueKey: localStorage.getItem('uniqueKey'),
          validationType: 'addressValidation',
          validationValue: this.state.originalAddress.toUpperCase(),
          validationZip: this.state.originalZip
        }
      };
      await API.get(apiName, path, myInit2).then(response => {
        // console.log(response);
        if (response['address'] === true && response['zip'] === true && this.state.originalCity !== "" && this.state.originalCity.toLowerCase() === localStorage.getItem("city").toLowerCase() && this.state.originalState !== "" && this.state.originalState === localStorage.getItem("state") ) {
          this.setState({
            mailVerified: true,
            saveMail: true,
            originalAddressError: false,
            originalCityError: false,
            originalStateError: false,
            originalZipError: false,
            editMail: false,
            address: this.state.originalAddress,
            zip: this.state.originalZip
          });
          this.props.dispatch({ type: "ADD_STREET", payload: this.state.originalAddress });
          this.props.dispatch({ type: "ADD_ZIP", payload: this.state.originalZip });
          if(checked === "mail") {
            if(this.state.mailChecked) {
              this.setState({mailChecked: false, message: "Your address has been successfully removed from the requested mailing list."})
              localStorage.setItem("mailNewstips", "2")
              this.handleMailPreferences();
            } else {
              this.setState({mailChecked: true, message: "Your address has been successfully added to the requested mailing list."})
              localStorage.setItem("mailNewstips", "1")
              this.handleMailPreferences();
            }
          }
          if (checked === "mail") {
            window.$('#mailModal').modal('hide');
          }
        } else {
          if(
            this.state.originalCity === "" ||
            this.state.originalCity.toLowerCase() !== localStorage.getItem("city").toLowerCase()
          ) {
            this.setState({
              originalCityError: true
            });
          }
          if(
            this.state.originalState === "" ||
            this.state.originalState !== localStorage.getItem("state")
          ) {
            this.setState({
              originalStateError: true
            });
          }
          if (response['address'] === false) {
            this.setState({originalAddressError: true});
          }
          if (response['zip'] === false) {
            this.setState({originalZipError: true});
          }
        }
      })
    } else if(this.state.newAddress === "") {
        this.setState({addressError : true});
        modalClose = false
      } else if(this.state.newCity === "") {
        this.setState({cityError : true});
        modalClose = false
      } else if(this.state.newState === "") {
        this.setState({stateError : true});
        modalClose = false
      } else if(this.state.newZip === "" || !this.state.newZip.match(zipRex)) {
        this.setState({zipError : true});
        modalClose = false
      } else {
        modalClose = true;
      this.setState({address : this.state.newAddress, city: this.state.newCity, state: this.state.newState, zip: this.state.newZip, message: "Your service address updated successfully." })
      this.props.dispatch({ type: "ADD_STREET", payload: this.state.newAddress });
      localStorage.setItem("city", this.state.newCity);
      localStorage.setItem("state", this.state.newState);
      this.props.dispatch({ type: "ADD_ZIP", payload: this.state.newZip });
      setTimeout(()=>{
        this.handleMailPreferences();
      }, 1000)
    }
  };
  editMail = () => {
    this.setState({editMail: true})
  }
  editMailingAddress = () => {
    checked = "";
    let address = this.props.reduxStreet;
    let zip = this.props.reduxZip;
    this.setState({
      maskAddress: address,
      maskZip: zip,
      editMail: false,
      addressError: false,
      cityError: false,
      stateError: false,
      zipError: false,
      address: this.state.originalAddress,
      zip: this.state.originalZip,
      city: this.state.originalCity,
      state: this.state.originalState,
      // originalAddress: "",
      // originalCity: "",
      // originalState: "",
      // originalZip: "",
      newAddress: "",
      newCity: "",
      newState: "",
      newZip: ""
    });
  };
  newEmailValidation(event) { 
    this.setState({confirmEmailError:false});
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //console.log("<< NEW EMAIL >> ",this.state.newEmail);
    //console.log("<< CONFIRM EMAIL >> ",this.state.confirmEmail);
    if( !this.state.newEmail.match(emailRex) || !this.state.confirmEmail.match(emailRex) || this.state.newEmail !== this.state.confirmEmail){
      this.setState({ emailError: true, confirmEmailError:true, confirmEmail:"", newEmail:"", newEmailError: true});
      console.log("<< Return >>");
      window.$('#emailModal').modal('show');
     
      return false;
    }else {
      window.$('#emailModal').modal('hide');
      this.setState({
        email: this.state.newEmail,
        emailError: false,
        message: "Email Address updated successfully.",
        confirmEmail:"",
        confirmEmailError:false,
        confirmEmailVerified: true,
        newEmailVerified: true
      });
      this.props.dispatch({ type: "ADD_EMAIL", payload: this.state.newEmail });
      setTimeout(()=>{
        this.handleEmailPreferences();
      }, 1000)
    }
   
};
 
  async emailValidation(event) {
    event.preventDefault();
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!this.state.editEmail) {
      if( this.props.reduxEmail !== "-") {
        if (this.state.originalEmail === "") {
          this.setState({ originalEmailError: true });
          return false;
        }
        let emailValue = await this.state.originalEmail.toLowerCase();
        let myInit2 = {
          headers: {
            uniqueKey: localStorage.getItem('uniqueKey'),
            validationType: 'emailValidation',
            validationValue: emailValue
          }
        };
        await API.get(apiName, path, myInit2).then(response => {
          // console.log(response);
          if (response['success'] === true) {
            // console.log('in success');
            this.setState({
              email: this.state.originalEmail,
              emailVerified: true,
              saveEmail: true,
              emailError: false,
              originalEmailError: false,
            });
            if(checked === "email") {
              window.$('#emailModal').modal('hide');
              if(this.state.emailChecked) {
                this.setState({emailChecked: false, message: "Your email address has been successfully removed from the requested email list."})
                localStorage.setItem("emailNewstips", "2")
                this.handleEmailPreferences();
              } else {
                this.setState({emailChecked: true, message: "Your email address has successfully been subscribed to the requested email list."})
                localStorage.setItem("emailNewstips", "1")
                this.handleEmailPreferences();
              }
            }
          } else {
            this.setState({ originalEmailError: true });
          }
        })
      } else if(this.props.reduxEmail === "-") {
        // console.log('3333333');
        if(!this.state.email.match(emailRex)) {
          // console.log("email error");
          this.setState({
            emailError: true
          });
        } else {
          // console.log("email success");
          let str = this.state.email;
          if(checked === "email") {
            window.$('#emailModal').modal('hide');
            if(this.state.emailChecked) {
              this.setState({emailChecked: false, message: "Your email address has been successfully added and removed from the requested email list."})
              localStorage.setItem("emailNewstips", "2")
              this.handleEmailPreferences();
            } else {
              this.setState({emailChecked: true, message: "Your email address has been successfully added and subscribed to the requested email list."})
              localStorage.setItem("emailNewstips", "1")
              this.handleEmailPreferences();
            }
          }
          this.setState({
            email: this.state.email,
            emailVerified: true,
            emailError: false,
            saveEmail: true,
            maskEmail: str
            // message: "Email added successfully"
          });
          this.props.dispatch({ type: "ADD_EMAIL", payload: this.state.email });
          setTimeout(()=>{
             this.handleEmailPreferences();
          }, 1000)
         
        }
      }
    } else if(!this.state.newEmail.match(emailRex) || this.state.newEmail === "") {
      this.setState({ emailError: true });
    } else {
      this.setState({
        email: this.state.newEmail,
        emailError: false,
        message: "Email Address updated successfully."
      });
      this.props.dispatch({ type: "ADD_EMAIL", payload: this.state.newEmail });
      setTimeout(()=>{
        this.handleEmailPreferences();
      }, 1000)
    }
  };

  editEmail = () => {
    this.setState({ editEmail: true });
  };
  editEmailAddress = () => {
    checked = "";
    let str = this.props.reduxEmail;
    // console.log(str);
    this.setState({
      editEmail: false,
      emailError: false,
      maskEmail: str,
      originalEmail: "",
      originalEmailError: "",
      newEmail: ""
    });
  };
  editPhone = () => {
    // console.log("edit phone")
    this.setState({ editPhone: true, newPhone: "", updatedPhone: false });
  };
  editPhoneNumber = () => {
    checked = ""
    // if(!this.state.editPhone) {
    let str = this.state.phoneNumber;
    // console.log(str);
    this.setState({
      editPhone: false,
      maskPhoneNumber: str,
      originalPhone: ""
    });
    // }
  };
  async phoneValidation(event) {
    // console.log(this.state.phoneError)
    event.preventDefault();
    const phone = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (!this.state.editPhone) {
      if(this.props.reduxPhone === "-") {
        if (!this.state.phoneNumber.match(phone)) {
          // console.log("phone error");
          this.setState({
            phoneError: true,
            smsConsentModal: true,
          });
        } else {
          // console.log(this.state.phoneNumber);
          this.setState({
            phoneError: false,
            close: false,
            smsConsentModal: false,
            savePhone: true,
            phoneVerified: true,
            message: "Phone number added successfully."
          });
          this.handlePhonePreferences();
          // console.log(this.state.savePhone);
        }
      } else if(this.props.reduxPhone !== "-") {
        if (this.state.originalPhone === "") {
          this.setState({ originalPhoneError: true });
          return false;
        }
        let myInit2 = {
          headers: {
            uniqueKey: localStorage.getItem('uniqueKey'),
            validationType: 'phoneValidation',
            validationValue: this.state.originalPhone
          }
        };
        await API.get(apiName, path, myInit2).then(response => {
          // console.log(response);
          if (response['success'] === true) {
            this.setState({
              phoneNumber: this.state.originalPhone,
              savePhone: true,
              phoneVerified: true,
              phoneError: false,
              smsConsentModal: false,
              originalPhoneError: false
            });
            if (checked === "phone") {
              window.$('#phoneModal').modal('hide');
              window.$('#smsConsentModal').modal('show');
            }
          } else {
            // console.log("inside if");
            this.setState({ originalPhoneError: true, smsConsentModal: true });
          }
        })
      }
      // console.log(this.state.savePhone);
    } else if(!this.state.newPhone.match(phone)) {
        this.setState({ phoneError: true });
      } else if(this.state.newPhone === "") {
        this.setState({ phoneError: true });
      } else {
        this.setState({ phoneNumber: this.state.newPhone, updatedPhone:true, smsConsent: 0, agree: false, disagree: false, close: false, phoneError: false });
      }
  };

  newPhoneValidation(event) {
    event.preventDefault(); 
    this.setState({confirmPhoneError:false});
    const phone = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;  
    if(!this.state.newPhone.match(phone) || !this.state.confirmPhone.match(phone) || this.state.newPhone !== this.state.confirmPhone){
      this.setState({ phoneError: true, confirmPhoneError:true, confirmPhone:"", newPhone:"", newPhoneError: true});
      console.log("Return");
      window.$('#phoneModal').modal('show');
      return false;
    } else {
      /*window.$('#phoneModal').modal('hide');*/
      window.$('smsConsentModal').modal('show');
      this.setState({
        phoneNumber: this.state.newPhone,
        phone: this.state.newPhone,
        phoneError: false,
        /*message: "Phone Number updated successfully.",*/
        confirmPhone:"",
        confirmPhoneError:false,
        confirmPhoneVerified: true,
        newPhoneVerified: true,
        newPhone:"",
        newPhoneError: false,
        agree: false,
        disagree: false
      });
      this.props.dispatch({ type: "ADD_PHONE", payload: this.state.newPhone });
      setTimeout(()=>{
        this.handlePhonePreferences();
      }, 1000)
    }
};
  async componentDidMount() {
    // console.log(this.props.reduxEmail);
    let params = new URLSearchParams(document.location.search.substring(1));
    let bill = params.get("ProgramGroupID");
    let rid = params.get("ReferenceID");
    // console.log(bill)
    if(rid !== null && rid !== "") {
      localStorage.setItem("ref", "yes")
      // console.log(rid);
      let myInit1 = {
        headers: {
          referenceId: rid.toLowerCase()
        }
      };
      await API.get(apiName, path, myInit1).then(response => {
        // console.log(response)
        if(response.length > 0) {
          localStorage.setItem("mKey", response[0].mKey);
          localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
          localStorage.setItem("uniqueKey", response[0].uniqueKey);
          localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
          localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
          localStorage.setItem("classification", response[0].classification);
          localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
          localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
          localStorage.setItem("smsGlobal", response[0]["preferences"]["global"]["sms"]["status"]);
          localStorage.setItem("emailNewstips", response[0]["preferences"]["newsTips"]["email"]["status"]);
          localStorage.setItem("mailNewstips", response[0]["preferences"]["newsTips"]["mail"]["status"]);
          this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
          this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
          
          this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
          
          this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
          
          // if (response[0].classification === "DIRECT") {
          //   this.setState({submit: true});
          // } else if (response[0].classification === "UTILITY") {
          //   this.setState({submit: true});
          // }
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/")
      });
    }
    if(localStorage.length === 0){
      // this.setState({page: "login"})
      this.props.history.push("/")
    } else {
      if((localStorage.getItem("classification") === "UTILITY" && bill.toUpperCase() !== "CONSTELLATION_UTILITY_BILLED") || (localStorage.getItem("classification") === "DIRECT" && bill.toUpperCase() !== "CONSTELLATION_ENERGY")) {
        this.setState({page: "error"})
      }
      // console.log(localStorage.getItem("ref"))
      if(localStorage.getItem("ref") === "yes" || localStorage.getItem("ref") === "true") {
        if(localStorage.getItem("ref") === "yes") {
          if(rid === null || rid === "") {
            // this.setState({page: "login"})
            this.props.history.push("/")
          }
        }
        
        let myInit1 = {
          headers: {
            uniqueMKey: localStorage.getItem('uniqueKey')
          }
        };
        await API.get(apiName, path, myInit1).then(response => {
          // console.log(response)
          if(response.length > 0){
            this.props.dispatch({ type: "EDIT", payload: { reduxEmail: response[0].email === undefined ? "-" : response[0].email, reduxPhone: response[0].phone === undefined ? "-" : response[0].phone, reduxStreet: response[0]["serviceAddress"]["address"], reduxZip:response[0]["serviceAddress"]["zip"]} });
          }
          if(response[0].email !== undefined && response[0].email !== "") {
            this.setState({ emailVerified: true, saveEmail: true})
          }
          if(response[0].phone !== undefined && response[0].phone !== "") {
            this.setState({ phoneVerified: true, savePhone: true})
          }
          this.setState({mailVerified: true, saveMail: true})
        });
      } else if(this.props.reduxEmail === "-"){
        let myInit1 = {
          headers: {
            uniqueKey: localStorage.getItem('uniqueKey')
          }
        };
        await API.get(apiName, path, myInit1).then(response => {
          // console.log(response)
          if(response.length > 0){
            this.props.dispatch({ type: "EDIT", payload: { reduxEmail: response[0].email === undefined ? "-" : response[0].email, reduxPhone: response[0].phone === undefined ? "-" : response[0].phone, reduxStreet: response[0]["serviceAddress"]["address"], reduxZip:response[0]["serviceAddress"]["zip"]} });
          }
        });
      }
      
      let nameFirst = "";
      let accountType = ""
      if(localStorage.getItem("nameFirst") === "undefined") {
        nameFirst = localStorage.getItem("nameLast")
        accountType = "business"
      } else {
        nameFirst = localStorage.getItem("nameFirst").charAt(0).toUpperCase() + localStorage.getItem("nameFirst").slice(1).toLowerCase();
        accountType = "home"
      }
      // console.log(nameFirst)
      this.setState({firstname: nameFirst, accountType: accountType, address: this.props.reduxStreet, city: localStorage.getItem("city"), state: localStorage.getItem("state"), zip: this.props.reduxZip})
      if(this.props.reduxPhone !== "-") {
        let str = this.props.reduxPhone;
        this.setState({phoneNumber: this.props.reduxPhone, maskPhoneNumber: str})
      }
      if(this.props.reduxEmail !== "-") {
        let str = this.props.reduxEmail;
        this.setState({maskEmail: str, email: this.props.reduxEmail})
      }
      if(this.props.reduxStreet !== "-") {
        let address = this.props.reduxStreet;
        let zip = this.props.reduxZip;
        this.setState({maskAddress: address, maskZip: zip})
      }

      if(this.props.reduxPhone !== "-" && this.props.reduxPhone !== undefined){
        if(localStorage.getItem("smsGlobal") === "0") {
          await this.setState({ agree: false, smsConsent: 0, textChecked: false });
        } else if(localStorage.getItem("smsGlobal") === "2") {
          await this.setState({
            smsConsent: 2,
            disagree: true,
            savePhone: true,
            phoneNumber: this.props.reduxPhone,
            textChecked: false
          });
        } else if(localStorage.getItem("smsGlobal") === "1") {
          await this.setState({
            agree: true,
            smsConsent: 1,
            textChecked: true,
            savePhone: true,
            phoneNumber: this.props.reduxPhone
          });
        }
      }
      else {
        await this.setState({ agree: false, smsConsent: 0, textChecked: false, savePhone: false });
      }
      if(localStorage.getItem("mailNewstips") === "1") {
        await this.setState({ mailChecked: true, address: this.props.reduxStreet, city: localStorage.getItem("city"), state: localStorage.getItem("state"), zip: this.props.reduxZip });
      } else if(localStorage.getItem("mailNewstips") === "2") {
        await this.setState({ mailChecked: false, address: this.props.reduxStreet, city: localStorage.getItem("city"), state: localStorage.getItem("state"), zip: this.props.reduxZip });
      } else if(localStorage.getItem("mailNewstips") === "0") {
        await this.setState({ mailChecked: false});
      }

      if(this.props.reduxEmail !== "-" && this.props.reduxEmail !== undefined){
        if(localStorage.getItem("emailNewstips") === "1") {
          await this.setState({
            email: this.props.reduxEmail,
            saveEmail: true,
            emailChecked: true
          });
        } else if(localStorage.getItem("emailNewstips") === "2") {
          await this.setState({
            email: this.props.reduxEmail,
            saveEmail: true,
            emailChecked: false
          });
        } else if(localStorage.getItem("emailNewstips") === "0") {
          await this.setState({ saveEmail: true, emailChecked: false });
        }
      }
      else{
        await this.setState({ saveEmail: false, emailChecked: false });
      }
    }
  }
  async handleMailPreferences() {
    let serviceAddress = {};
    let mKey = "";
    if(checked==="") {
      let myInit1 = {
        headers: {
          nameLast: localStorage.getItem("nameLast").toUpperCase(),
          address: this.props.reduxStreet.toUpperCase(),
          zip: this.props.reduxZip,
        }
      };
      setTimeout(() => 1000);
      await API.get(apiName, "/checkMkey", myInit1).then(response => {
        mKey = response;
        // this.setState({ mKey: response });
      });
      serviceAddress = {
        mKey: mKey,
        address: this.props.reduxStreet.toUpperCase(),
        city: localStorage.getItem("city").toUpperCase(),
        state: localStorage.getItem("state"),
        zip: this.props.reduxZip,
        serviceAddressUpdate: new Date().toJSON(),
        lastModifiedDate: new Date().toJSON()
      }
    } else {
      // console.log("mail update")
      serviceAddress = {
        mailNewstips: localStorage.getItem("mailNewstips"),
        mailNewsTipsUpdate: new Date().toJSON(),
        lastModifiedDate: new Date().toJSON()
      }
    }
    let myInit1 = {
      headers: {
        uniqueKey: localStorage.getItem("uniqueKey")
      },
      body: serviceAddress
    };
    API.put(apiName, path, myInit1)
    .then(response => {
      // console.log(response)
      localStorage.setItem('mKey', response.data['Attributes']['mKey'])
      this.showNotification();
    })
    .catch(error => {
      console.log(error);
    });
  }
  handleEmailPreferences = () => {
    // console.log(checked);
    let myInit1 = {
      headers: {
        uniqueKey: localStorage.getItem("uniqueKey"),
      },
      body: {
        emailNewstips: localStorage.getItem("emailNewstips"),
        emailNewsTipsUpdate: new Date().toJSON(),
        lastModifiedDate: new Date().toJSON()
      }
    };
    if(checked === "" || !this.state.emailVerified){
      myInit1['body']['email'] =  this.state.email.toLowerCase()
    }
    // console.log(myInit1)
    API.put(apiName, path, myInit1)
    .then(response => {
      // console.log(response)
      this.showNotification();
    })
    .catch(error => {
      console.log(error);
    });
  }
  handlePhonePreferences = () => {
    // console.log("handlePhonePreferences")
    // console.log(new Date().toJSON())
    this.props.dispatch({ type: "ADD_PHONE", payload: this.state.phoneNumber });
    let myInit1 = {
      headers: {
        uniqueKey: localStorage.getItem("uniqueKey"),
      },
      body: {
        phone: this.state.phoneNumber,
        smsGlobal: localStorage.getItem("smsGlobal"),
        smsGlobalUpdate: new Date().toJSON(),
        lastModifiedDate: new Date().toJSON()
      }
    };
    API.put(apiName, path, myInit1)
    .then(response => {
      // console.log(response)
      this.showNotification();
    })
    .catch(error => {
      console.log(error);
    });
  }
  showNotification = () => {
    // console.log("notification");
    this.setState({notification: true})
    setTimeout(
      function() {
        this.setState({notification: false});
      }.bind(this),
      2500
    );
  }

  render() {
    if(this.state.page === "error") {
      return <PageNotFound />
    }
    // if(this.state.page === "login") {
    //   this.props.history.push("/")
    // }
    return (
      <React.Fragment>
      <Header/>
      <main>
        <div className={this.state.notification ? "snackbarHidden snackbarShow" : "snackbarHidden"}>{this.state.message}</div>
        <div className="container description">
          <h1>My Preferences</h1>
          <h2>Welcome {this.state.firstname}!</h2>
          {/* <h5>Now you can easily manage your marketing preferences in one location.</h5> */}
          {/* <h5>Do you prefer to receive text messages about upcoming promotions instead of having them mailed to your {this.state.accountType}? Are you interested in learning about ways that you can save energy? */}
          <h5>Now you’re in control and you can update your preferences at any time!</h5> 
          <h5>Simply check the boxes indicating the types of Constellation communications you  would like to receive and how you prefer to receive them.</h5>  
       </div> 
        <div className="container formContainer">
          <div className="row">
            <div>
              <form>
                <table className="table">
                  <thead className="fontMedium">
                    <tr>
                      <td>
                        <p className="text-left">
                          Preferences
                        </p>
                      </td>
                      <td>
                        <div>Email Address:</div>
                        <i className="fa fa-at theadIcon" />
                        <div>
                          <a
                            href=""
                            className={this.props.reduxEmail !== "-" ? "" : "invisible"}
                            onClick={this.editEmailAddress}
                            data-toggle="modal"
                            data-target="#emailModal"
                          >
                            Edit Email
                          </a>
                        </div>
                      </td>
                     
                      <td>
                        <div>Text</div>
                        <i className="fa fa-mobile theadIcon" />
                        <div>
                          <a
                            href=""
                            className={(this.props.reduxPhone !== "-") ? "" : "invisible"}
                            onClick={this.editPhoneNumber}
                            data-toggle="modal"
                            data-target="#phoneModal"
                          >
                            Edit Phone Number
                          </a>
                        </div>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <h4 className="fontLarge text-left">
                          Text Messages from Constellation
                        </h4>
                        <p className="fontMedium text-left">
                          Receive important account related notifications by
                          text message.
                        </p>
                      </td>
                      <td>
                        <span className="fa fa-stack fa-opt-disabled">
                          <i className="fa fa-minus" />
                        </span>
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          name="phone"
                          onChange={this.handleTextChecked}
                          checked={this.state.textChecked}
                          data-toggle="modal"
                          data-target={this.state.phoneVerified ? "#smsConsentModal" : "#phoneModal"}
                        />
                      </td> 
                    </tr> 
                    <tr>
                      <td>
                        <h4 className="fontLarge text-left">
                          News and Tips from Constellation
                        </h4> 
                        <a
                          href=""
                          data-toggle="modal"
                          data-target="#previewModal"
                          className="pull-right"
                        >
                          Preview
                        </a>
                        <p className="fontMedium text-left">
                          News and Tips informs you about your energy usage, new
                          product launches, our blog posts that provide useful
                          energy-saving information and more.
                        </p>
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          name="email"
                          onChange={this.handleEmailChecked}
                          checked={this.state.emailChecked}
                          data-toggle={this.state.emailVerified ? "" : "modal"}
                          data-target="#emailModal"
                        />
                      </td> 
                      <td>
                        <span className="fa fa-stack fa-opt-disabled">
                          <i className="fa fa-minus" />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>
          <div
            className="modal fade"
            id="phoneModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="phoneModalTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5
                    className="modal-title text-center fontLarge"
                    id="phoneModalTitle"
                  >
                    { (this.props.reduxPhone !== "-" && !this.state.phoneVerified) ? "Please confirm the existing phone number."   
                      : this.props.reduxPhone === "-" && !this.state.savePhone ? "Add Your Text Number"
                      : (this.state.savePhone && (!this.state.agree && !this.state.disagree)) ? "Update SMS Consent" : "Edit Your Text Number"
                    }
                  </h5>
                  <button
                    type="button"
                    className={!this.state.close ? "hidden" : "close"}
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.unCheckText}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body fontMedium text-justify">
                  <div className={this.state.agree || this.state.disagree || !this.state.savePhone ? "" : "hidden"}>
                    <div className="row">
                      <div className="col-12">
                        <div className={!this.state.editPhone ? "" : "hidden"}>
                          <div className={this.props.reduxPhone === "-" || this.state.phoneVerified ? "" : "hidden"}>
                            <p className={!this.state.phoneVerified && !this.state.savePhone ? "text-left fontMedium" : "hidden"}>Please enter your phone number without dashes.</p>
                            <label>New Phone Number: </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              className="form-control input col-8"
                              id="contact-phone"
                              name="ContactElementInfo.Phone"
                              type="text"
                              onChange={this.handleNewPhoneChange}
                              required
                              value={this.state.newPhone}
                              /*disabled={!this.state.savePhone ? "" : true} */
                            />
                             <p>
                            </p>
                            <label>Confirm Phone Number: </label>
                             
                            <input
                              className="form-control input col-8"
                              id="contact-phone"
                              name="ContactElementInfo.Phone"
                              type="text"
                              onChange={this.handleConfirmPhoneChange}
                              required          
                              value={this.state.confirmPhone}
                            />
                            <button
                              type="submit"
                              className="button col-4"
                              onClick={this.newPhoneValidation}
                              /*data-dismiss={modalClose ? "modal" : ""}*/
                            >
                              CONFIRM
                            </button>
                             <p>
                            <br />
                            Note: Changes made here are not applied to your account
                            </p>
                            <p className={!this.state.newPhoneError ? "hidden" : "text-center error"}>
                              <small>
                                The phone numbers do not match. Please try again.
                              </small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={(this.state.savePhone) && (!this.state.agree && !this.state.disagree) ? "" : "hidden"}>
                    <div>
                      <p>
                      I hereby consent to receive autodialed and or pre-recorded telemarketing calls 
                      and/or text messages from or on behalf of Constellation at the telephone number 
                      listed above.
                        <a
                          href="https://www.constellation.com/sms-terms.html"
                          target="constellation_terms"
                        >
                          &nbsp;Terms
                        </a>
                        .{" "}
                        <a
                          href="https://www.constellation.com/privacy-policy.html"
                          target="constellation_privacy"
                        >
                          Privacy Policy
                        </a>
                        . I understand that this consent is not a condition of
                        purchasing any goods or services from Constellation.
                      </p>
                      <div className= "col-12 text-center">
                        <button
                          type="submit"
                          className="agreeButton"
                          onClick={this.handleAgree}
                          data-dismiss="modal"
                        >
                          I AGREE
                        </button>
                      </div>
                      <br />
                    </div>
                    <div>
                      
                      <div className={this.state.savePhone && !this.state.disagree ? "" : "hidden"}>
                        <p>
                          Revoking your consent will deactivate all SMS preferences for this user
                        </p>
                        <div className="col-12 text-center">
                          <button
                            type="submit"
                            className="disagreeButton"
                            onClick={this.handleDisagree}
                            data-dismiss="modal"
                          >
                            REVOKE CONSENT
                          </button>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className={this.props.reduxPhone !== "-" && !this.state.phoneVerified ? "" : "hidden"}>
                      <p className="text-left fontMedium">Please confirm the existing phone number</p>
                        <label>Phone Number: </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          className="form-control input"
                          id="contact-phone"
                          name="ContactElementInfo.Phone"
                          type="text"
                          required
                          value={!this.state.phoneVerified ? this.state.maskPhoneNumber : this.state.phoneNumber}
                          disabled
                        />
                        <p>
                          <br />
                          To edit your text number or sms preferences, please confirm your identity by entering your existing text number without dashes.
                        </p>
                        <label>Confirm Phone Number: </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          className="form-control input col-8"
                          id="contact-phone"
                          name="ContactElementInfo.Phone"
                          type="text"
                          onChange={this.handleOriginalPhoneChange}
                          required
                          value={this.state.originalPhone}
                        />
                        <button
                          type="submit"
                          className="button col-4"
                          onClick={this.phoneValidation}
                        >
                          CONFIRM
                        </button>
                        <p className={!this.state.originalPhoneError ? "hidden" : "text-center error"}>
                          <small>
                            The phone numbers do not match. Please try again.
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="smsConsentModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="smsConsentModalTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5
                    className="modal-title text-center fontLarge"
                    id="smsConsentModalTitle"
                  >
                    Update SMS Preferences
                  </h5>
                  <button
                    type="button"
                    className={!this.state.close ? "hidden" : "close"}
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.unCheckText}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body fontMedium text-justify">
                  <div 
                    className={this.state.smsConsent !==1 ? "" : "hidden"}
                  >
                    <p>
                      I hereby consent to receive autodialed and or pre-recorded telemarketing calls 
                      and/or text messages from or on behalf of Constellation at the telephone number 
                      listed above.
                      <a
                        href="https://www.constellation.com/sms-terms.html"
                        target="constellation_terms"
                      >
                        &nbsp;Terms
                      </a>
                      .{" "}
                      <a
                        href="https://www.constellationenergy.com/privacy-policy.html"
                        target="constellation_privacy"
                      >
                        Privacy Policy
                      </a>
                      . I understand that this consent is not a condition of
                      purchasing any goods or services from Constellation.
                    </p>
                    <div className= "col-12 text-center">
                      <button
                        type="submit"
                        className="agreeButton"
                        onClick={this.handleAgree}
                        data-dismiss="modal"
                      >
                        I AGREE
                      </button>
                    </div>
                    <br />
                  </div>
                  <div
                    className={this.state.smsConsent !==2 ? "" : "hidden"}
                  >
                    <p>
                      Revoking your consent will deactivate all SMS preferences for this user
                    </p>
                    <div className={
                      this.state.savePhone && !this.state.disagree
                        ? "col-12 text-center"
                        : "hidden"
                    }>
                      <button
                        type="submit"
                        className="disagreeButton"
                        onClick={this.handleDisagree}
                        data-dismiss="modal"
                      >
                        REVOKE CONSENT
                      </button>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div> 
          </div>  
          <div
            className="modal fade"
            id="emailModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="emailModalTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title fontLarge" id="emailModalTitle">
                    {(this.props.reduxEmail !== "-" && !this.state.emailVerified && !this.newPhoneError) ? "Please confirm the existing email address."   
                      : this.props.reduxEmail === "-"  && !this.state.saveEmail ? "Add Your Email Address" : "New Email Address" }
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.unCheckEmail}
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body fontMedium text-justify">
                  <p>
                    {(this.props.reduxEmail === "-"  && !this.state.saveEmail) || this.state.editEmail ? "You must provide a preferred email address to opt in to this program."
                      : (this.props.reduxEmail !== "-" && !this.state.emailVerified) ? "Confirm the existing email address on file" : ""
                    }
                  </p>
                  <div className="row">
                    <div className="col-12">
                     
                      <div
                     className={(this.props.reduxEmail === "-" || this.state.confirmEmailError === true ||  this.state.emailVerified)  ? "" : "hidden"}
                      >
                        <div className="text-left">
                         <label>New Email Address:</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            className="form-control input"
                            id="contact-email"
                            name="ContactElementInfo.Email"
                            type="email"
                            onChange={this.handleNewEmailChange}
                            required          
                            value={this.state.newEmail}
                          />
                          <p>
                          </p>
                          <label>Confirm new email: </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            className="form-control input"
                            id="contact-email"
                            name="ContactElementInfo.Email"
                            type="email"
                            onChange={this.handleConfirmEmailChange}
                            required          
                            value={this.state.confirmEmail}
                          />
                          <button
                            type="submit"
                            className="button col-4"
                            onClick={this.newEmailValidation}
                            /*data-dismiss={modalClose ? "modal" : ""} */
                          >
                            CONFIRM
                          </button>
                          <p>
                          <br />
                          Note: Changes made here are not applied to your account
                          </p>
                        </div>
                      </div>
                      <p className="text-center error">
                        {!this.state.confirmEmailError ? (
                          ""
                        ) : (
                          <small>
                            The email addresses do not match. Please try again.
                          </small>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className={this.props.reduxEmail !== "-" && !this.state.emailVerified ? "" : "hidden"}>
                    <div className="text-left">
                      <label>Email Address: </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <input
                        className="form-control input col-8"
                        id="contact-email"
                        name="ContactElementInfo.Email"
                        type="email"
                        onChange={this.handleEmailChange}
                        disabled
                        // required
                        value={!this.state.emailVerified ? this.state.maskEmail : this.state.email}
                      />
                      <p>
                        <br />
                        To edit or opt-in your email address, please confirm your identity by entering your existing email address.
                      </p>
                      <label>Confirm current email: </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <input
                        className="form-control input col-12"
                        id="originalEmail"
                        name="originalEmail"
                        type="email"
                        onChange={this.handleOriginalEmailChange}
                        required
                        value={this.state.originalEmail}
                      />
                      <button
                        type="submit"
                        className="button col-4"
                        onClick={this.emailValidation}
                      >
                        CONFIRM
                      </button>
                      <p className="text-center error">
                        {!this.state.originalEmailError ? (
                          ""
                        ) : (
                          <small>
                            The email addresses do not match. Please try again.
                          </small>
                        )}
                      </p>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
          <div className="modal fade" id="previewModal" tabIndex="-1" role="dialog" aria-labelledby="previewModalTitle" aria-hidden="true">
            <div className="modal-dialog modal-sm" style={{width:'20%'}}>
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body fontMedium" style={{height:'50%'}}>
                  <img alt="preview" src={Preview} style={{width:'100%'}}/>
                </div>
              </div>      
            </div>
          </div>
        </div>
      </main>
      <Footer/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  reduxEmail: state.reduxEmail,
  reduxPhone: state.reduxPhone,
  reduxStreet: state.reduxStreet,
  reduxZip: state.reduxZip
});

export default connect(mapStateToProps)(WithAccountNumber);



// WEBPACK FOOTER //
// ./src/views/CustomerPages/withAccountNumber.jsx